import { render, staticRenderFns } from "./GraffidiConfigurazioneList.vue?vue&type=template&id=fcc801be"
import script from "./GraffidiConfigurazioneList.vue?vue&type=script&lang=js"
export * from "./GraffidiConfigurazioneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports